import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

const call = (name, payload) => httpsCallable(functions, name)(payload).then((result) => result.data);

export const beginEncryptionTransition = (payload) => call('beginEncryptionTransition', payload);
export const commitEncryptionTransition = (payload) => call('commitEncryptionTransition', payload);
export const abortEncryptionTransition = (payload) => call('abortEncryptionTransition', payload);
